!(function(global){
	function IMGSlider(wrapper){
		this.wrapper = _dom(wrapper);
		this.current = 0;

		this.sizes = {};
		this.sizes.x600 = this.wrapper.attr('data-600').split(',');
		this.sizes.x480 = this.wrapper.attr('data-480').split(',');
		this.sizes.x240 = this.wrapper.attr('data-240').split(',');
		this.sizes.x160 = this.wrapper.attr('data-160').split(',');

		this.length = this.sizes.x600.length;

		this.size = 0;
		this.checkers = [];

		this._renderMenu();
	}

	IMGSlider.prototype._renderMenu = function(){
		if(this.length <= 1){
			return
		}

		this.menu = _newEl('div', {
			'styles':{
				'position': 'absolute',
				'height': '20px',
				'width': 40 * (this.length-1) + 'px'
			}
		}).insert(this.wrapper);

		var that = this;
		for(var i = 0, l = this.length; i < l; i++){
			(function(iterator){
				that.checkers.push(_newEl('span', {
					'class': 'imgSliderCircle' + (that.current === i ? ' currentIMG' : ' otherIMG')
				}));

				that.checkers[i].insert(that.menu).on('tap', function(){
					that._changePhoto(iterator);
				})
			})(i);
		}

		this._placeMenu();

	};

	IMGSlider.prototype._placeMenu = function(){
		if(typeof this.menu === 'undefined'){
			return
		}

		if(window.innerWidth < 650 && window.innerWidth > window.innerHeight){
			this.menu.css({
				'top': '50%',
				'left': (this.size/2) + 'px',
				'marginLeft': - (40 * (this.length-1) / 2) + 'px',
				'marginTop': (this.size/2)-20 + 'px'
			});
		}else if(window.innerWidth < 650){
			this.menu.css({
				'top': '0px',
				'left': '50%',
				'marginLeft': - (40 * (this.length-1) / 2) + 'px',
				'marginTop': '0px'
			});
		}else{
			this.menu.css({
				'top': '50%',
				'left': '50%',
				'marginLeft': - (40 * (this.length-1) / 2) + 'px',
				'marginTop': (this.size/2)-20 + 'px'
			});
		}
	};

	IMGSlider.prototype._changePhoto = function(pos){
		this.current = pos;

		_.each(this.checkers, function(item, i){
			item.removeClass('currentIMG').addClass('otherIMG');
		}, this);

		this.checkers[this.current].removeClass('otherIMG').addClass('currentIMG');

		this.wrapper.css({
			'backgroundImage': 'url("'+ this.sizes['x'+this.size][this.current] +'")'
		});

	};


	IMGSlider.prototype.setSize = function(size){
		this.size = size;

		this.wrapper.css({
			'backgroundImage': 'url("'+ this.sizes['x'+this.size][this.current] +'")'
		});

		this._placeMenu();
	};

	global.IMGSlider = IMGSlider;
})(this);